import { useMemo } from 'react';
import { useTranslation } from '../contexts/TranslationContext.tsx';

type TranslationValue = string | Record<string, unknown>;

function lookup(tree: unknown, key: string): string | undefined {
  const keys = key.split('.');
  let current: TranslationValue | undefined = tree as TranslationValue;
  for (const k of keys) {
    if (typeof current === 'object' && current !== null && k in current) {
      current = (current as Record<string, TranslationValue>)[k];
    } else {
      return undefined;
    }
  }
  return typeof current === 'string' ? current : undefined;
}

/**
 * Юридические страницы: русский, пока пользователь явно не выбрал EN в переключателе.
 */
export function useLegalDocumentT() {
  const { t, currentLanguage, translations } = useTranslation();

  const legalLang = useMemo(() => {
    try {
      if (localStorage.getItem('preferredLanguage') === 'en') return 'en';
    } catch {
      /* ignore */
    }
    return 'ru';
  }, [currentLanguage]);

  const tLegal = (key: string): string => {
    return (
      lookup(translations[legalLang], key) ||
      lookup(translations.ru, key) ||
      lookup(translations.en, key) ||
      t(key)
    );
  };

  return { t: tLegal, legalLang };
}
